module.exports = __webpack_public_path__ + "img/20210722.8421fb58.gif";